import Checkbox from '@anm/components/form/Checkbox';
import { FC } from 'react';

import { CheckBoxWrapper } from './Wrapper';

type PlayButtonCheckboxProps = {
  isChecked: boolean;
  onCheckBoxChange: () => void;
};

const PlayButtonCheckbox: FC<PlayButtonCheckboxProps> = ({
  isChecked,
  onCheckBoxChange
}) => (
  <CheckBoxWrapper checked={isChecked}>
    <Checkbox checked={isChecked} onChange={onCheckBoxChange} />
    <span>Play button</span>
  </CheckBoxWrapper>
);

export default PlayButtonCheckbox;
